export default "__VITE_ASSET__DK6n8uqL__"